import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { GetClientesERPSocioEnAPI, SetClientesERPSocioEnAPI } from "../../action/actionCreatorsRequests"
import { MSGOK, traducirPagina } from '../../librerias/funciones'
import {
    SaveOutlined,
    CloseOutlined

} from '@ant-design/icons';

import { Card, Input, Row, Col, Drawer, Tabs } from 'antd';
const { TabPane } = Tabs;

const MantenimientoClienteTaller = ({ props, configApp }) => {
    const [hayClientes, setHayClientes] = React.useState(false);
    const [tabPorDefecto, setTabPorDefecto] = React.useState("1");
    const [vehiculos, setVehiculos] = React.useState([]);
    const [actualizarVehiculos, setActualizarVehiculos] = React.useState([]);

    const [datosCliente, setDatosCliente] = React.useState(
        {
            id: null,
            codigo: null,
            nombre: "",
            direccion: "",
            poblacion: "",
            provincia: "",
            cp: "",
            pais: "",
            telefono1: "",
            telefono2: "",
            telefono3: "",
            email: "",
            observacion: "",
            cif: "",
            idSocio: ""
        }
    );

    if (!hayClientes && props.ABRIR_FICHA) {
        setHayClientes(true);
        if (Object.keys(props.CLIENTE_SELECCIONADO).length > 0) {
            GetClientesERPSocioEnAPI(props.CLIENTE_SELECCIONADO.ID, 1, "A", props.CLIENTE_SELECCIONADO.ID_SOCIO).then((cli) => {
                if (cli.CLIENTES !== null) {
                    let datosAPI = cli.CLIENTES[0];
                    setDatosCliente({
                        id: datosAPI.ID,
                        codigo: datosAPI.CODIGO,
                        nombre: datosAPI.NOMBRE,
                        direccion: datosAPI.DIRECCION,
                        poblacion: datosAPI.POBLACION,
                        provincia: datosAPI.PROVINCIA,
                        cp: datosAPI.CP,
                        pais: datosAPI.PAIS,
                        telefono1: datosAPI.TELEFONO,
                        telefono2: datosAPI.TELEFONO_2,
                        telefono3: datosAPI.TELEFONO_3,
                        email: datosAPI.MAIL,
                        observacion: datosAPI.OBSERVACIONES,
                        cif: datosAPI.CIF,
                        idSocio: datosAPI.ID_SOCIO
                    })
                }
            })
        } else {
            datosCliente.idSocio = props.ID_SOCIO
            setDatosCliente(datosCliente)
        }

    } else {
        if (!props.ABRIR_FICHA && hayClientes) {
            setHayClientes(false);
            setVehiculos([])
            setTabPorDefecto("1");
            setDatosCliente({
                id: null,
                codigo: null,
                nombre: "",
                direccion: "",
                poblacion: "",
                provincia: "",
                cp: "",
                pais: "",
                telefono1: "",
                telefono2: "",
                telefono3: "",
                email: "",
                observacion: "",
                cif: "",
                idSocio: ""
            })
        }
    }

    /*

    if (!actualizarVehiculos && VehiculoTallerSeleccionado.actualizarListaVehiculo) {
        store.dispatch({ type: "UPDATE_LISTA_CLIENTE_VEHICULO", actualizarListaVehiculo: false })
        setActualizarVehiculos(true);
        if (VehiculoTallerSeleccionado.esNuevoVehiculo) {
            getClienteVehiculosEnAPI("", 1, "A", clienteTallerSeleccionado.id).then((coches) => {
                if (coches.CLIENTES_VEHICULOS !== null) {
                    setVehiculos(coches.CLIENTES_VEHICULOS);
                }
            })
        } else {
            let modificarVehiculo = VehiculoTallerSeleccionado.clienteVehiculoTaller;
            vehiculos.map((item, index) => {
                if (item.ID == modificarVehiculo.ID) {
                    vehiculos[index].ID = modificarVehiculo.ID;
                    vehiculos[index].ID_TALLER = modificarVehiculo.ID_TALLER;
                    vehiculos[index].ID_TECDOC = modificarVehiculo.ID_TECDOC;
                    vehiculos[index].ID_CLIENTE = modificarVehiculo.ID_CLIENTE;
                    vehiculos[index].MATRICULA = modificarVehiculo.MATRICULA;
                    vehiculos[index].DESCRIPCION = modificarVehiculo.DESCRIPCION;
                    vehiculos[index].BASTIDOR = modificarVehiculo.BASTIDOR;
                    vehiculos[index].MARCA = modificarVehiculo.MARCA;
                    vehiculos[index].MODELO = modificarVehiculo.MODELO;
                    vehiculos[index].MOTOR = modificarVehiculo.MOTOR;
                    vehiculos[index].OBSERVACIONES = modificarVehiculo.OBSERVACIONES;
                }
            })
            setVehiculos(vehiculos)
        }
        store.dispatch({ type: "UPDATE_CLIENTE_VEHICULO_TALLER", clienteVehiculoTaller: {} })
    } else {
        if (!VehiculoTallerSeleccionado.actualizarListaVehiculo && actualizarVehiculos) {
            setActualizarVehiculos(false);
        }
    }
*/




    const guardarDatosCliente = (e) => {
        let modificar = {
            id: null,
            codigo: null,
            nombre: "",
            direccion: "",
            poblacion: "",
            provincia: "",
            cp: "",
            pais: "",
            telefono1: "",
            telefono2: "",
            telefono3: "",
            email: "",
            observacion: "",
            cif: "",
            idSocio: ""
        }

        switch (e.target.name) {
            case "codigo":
                modificar.codigo = e.target.value;
                modificar.id = datosCliente.id;
                modificar.nombre = datosCliente.nombre;
                modificar.direccion = datosCliente.direccion;
                modificar.poblacion = datosCliente.poblacion;
                modificar.provincia = datosCliente.provincia;
                modificar.cp = datosCliente.cp;
                modificar.telefono1 = datosCliente.telefono1;
                modificar.telefono2 = datosCliente.telefono2;
                modificar.telefono3 = datosCliente.telefono3;
                modificar.email = datosCliente.email;
                modificar.observacion = datosCliente.observacion;
                modificar.cif = datosCliente.cif;
                modificar.pais = datosCliente.pais;
                modificar.idSocio = datosCliente.idSocio;
                setDatosCliente(modificar)
                break;
            case "nombre":
                modificar.nombre = e.target.value;
                modificar.id = datosCliente.id;
                modificar.codigo = datosCliente.codigo;
                modificar.direccion = datosCliente.direccion;
                modificar.poblacion = datosCliente.poblacion;
                modificar.provincia = datosCliente.provincia;
                modificar.cp = datosCliente.cp;
                modificar.telefono1 = datosCliente.telefono1;
                modificar.telefono2 = datosCliente.telefono2;
                modificar.telefono3 = datosCliente.telefono3;
                modificar.email = datosCliente.email;
                modificar.observacion = datosCliente.observacion;
                modificar.cif = datosCliente.cif;
                modificar.pais = datosCliente.pais;
                modificar.idSocio = datosCliente.idSocio;
                setDatosCliente(modificar)
                break;
            case "direccion":
                modificar.direccion = e.target.value;
                modificar.id = datosCliente.id;
                modificar.codigo = datosCliente.codigo;
                modificar.nombre = datosCliente.nombre;
                modificar.poblacion = datosCliente.poblacion;
                modificar.provincia = datosCliente.provincia;
                modificar.cp = datosCliente.cp;
                modificar.telefono1 = datosCliente.telefono1;
                modificar.telefono2 = datosCliente.telefono2;
                modificar.telefono3 = datosCliente.telefono3;
                modificar.email = datosCliente.email;
                modificar.observacion = datosCliente.observacion;
                modificar.cif = datosCliente.cif;
                modificar.pais = datosCliente.pais;
                modificar.idSocio = datosCliente.idSocio;
                setDatosCliente(modificar)
                break;
            case "poblacion":
                modificar.poblacion = e.target.value;
                modificar.id = datosCliente.id;
                modificar.codigo = datosCliente.codigo;
                modificar.nombre = datosCliente.nombre;
                modificar.direccion = datosCliente.direccion;
                modificar.provincia = datosCliente.provincia;
                modificar.cp = datosCliente.cp;
                modificar.telefono1 = datosCliente.telefono1;
                modificar.telefono2 = datosCliente.telefono2;
                modificar.telefono3 = datosCliente.telefono3;
                modificar.email = datosCliente.email;
                modificar.observacion = datosCliente.observacion;
                modificar.cif = datosCliente.cif;
                modificar.pais = datosCliente.pais;
                modificar.idSocio = datosCliente.idSocio;
                setDatosCliente(modificar)
                break;
            case "provincia":
                modificar.provincia = e.target.value;
                modificar.id = datosCliente.id;
                modificar.codigo = datosCliente.codigo;
                modificar.nombre = datosCliente.nombre;
                modificar.direccion = datosCliente.direccion;
                modificar.poblacion = datosCliente.poblacion;
                modificar.cp = datosCliente.cp;
                modificar.telefono1 = datosCliente.telefono1;
                modificar.telefono2 = datosCliente.telefono2;
                modificar.telefono3 = datosCliente.telefono3;
                modificar.email = datosCliente.email;
                modificar.observacion = datosCliente.observacion;
                modificar.cif = datosCliente.cif;
                modificar.pais = datosCliente.pais;
                modificar.idSocio = datosCliente.idSocio;
                setDatosCliente(modificar)
                break;
            case "cp":
                modificar.cp = e.target.value;
                modificar.id = datosCliente.id;
                modificar.codigo = datosCliente.codigo;
                modificar.nombre = datosCliente.nombre;
                modificar.direccion = datosCliente.direccion;
                modificar.poblacion = datosCliente.poblacion;
                modificar.provincia = datosCliente.provincia;
                modificar.telefono1 = datosCliente.telefono1;
                modificar.telefono2 = datosCliente.telefono2;
                modificar.telefono3 = datosCliente.telefono3;
                modificar.email = datosCliente.email;
                modificar.observacion = datosCliente.observacion;
                modificar.cif = datosCliente.cif;
                modificar.pais = datosCliente.pais;
                modificar.idSocio = datosCliente.idSocio;
                setDatosCliente(modificar)
                break;
            case "pais":
                modificar.pais = e.target.value;
                modificar.id = datosCliente.id;
                modificar.codigo = datosCliente.codigo;
                modificar.nombre = datosCliente.nombre;
                modificar.direccion = datosCliente.direccion;
                modificar.poblacion = datosCliente.poblacion;
                modificar.provincia = datosCliente.provincia;
                modificar.cp = datosCliente.cp;
                modificar.telefono1 = datosCliente.telefono1;
                modificar.telefono2 = datosCliente.telefono2;
                modificar.telefono3 = datosCliente.telefono3;
                modificar.email = datosCliente.email;
                modificar.observacion = datosCliente.observacion;
                modificar.cif = datosCliente.cif;
                modificar.idSocio = datosCliente.idSocio;
                setDatosCliente(modificar)
                break;
            case "telefono1":
                modificar.telefono1 = e.target.value;
                modificar.id = datosCliente.id;
                modificar.codigo = datosCliente.codigo;
                modificar.nombre = datosCliente.nombre;
                modificar.direccion = datosCliente.direccion;
                modificar.poblacion = datosCliente.poblacion;
                modificar.provincia = datosCliente.provincia;
                modificar.cp = datosCliente.cp;

                modificar.telefono2 = datosCliente.telefono2;
                modificar.telefono3 = datosCliente.telefono3;
                modificar.email = datosCliente.email;
                modificar.observacion = datosCliente.observacion;
                modificar.cif = datosCliente.cif;
                modificar.pais = datosCliente.pais;
                modificar.idSocio = datosCliente.idSocio;
                setDatosCliente(modificar)
                break;
            case "telefono2":
                modificar.telefono2 = e.target.value;
                modificar.id = datosCliente.id;
                modificar.codigo = datosCliente.codigo;
                modificar.nombre = datosCliente.nombre;
                modificar.direccion = datosCliente.direccion;
                modificar.poblacion = datosCliente.poblacion;
                modificar.provincia = datosCliente.provincia;
                modificar.cp = datosCliente.cp;
                modificar.telefono1 = datosCliente.telefono1;

                modificar.telefono3 = datosCliente.telefono3;
                modificar.email = datosCliente.email;
                modificar.observacion = datosCliente.observacion;
                modificar.cif = datosCliente.cif;
                modificar.pais = datosCliente.pais;
                modificar.idSocio = datosCliente.idSocio;
                setDatosCliente(modificar)
                break;
            case "telefono3":
                modificar.telefono3 = e.target.value;
                modificar.id = datosCliente.id;
                modificar.codigo = datosCliente.codigo;
                modificar.nombre = datosCliente.nombre;
                modificar.direccion = datosCliente.direccion;
                modificar.poblacion = datosCliente.poblacion;
                modificar.provincia = datosCliente.provincia;
                modificar.cp = datosCliente.cp;
                modificar.telefono1 = datosCliente.telefono1;
                modificar.telefono2 = datosCliente.telefono2;

                modificar.email = datosCliente.email;
                modificar.observacion = datosCliente.observacion;
                modificar.cif = datosCliente.cif;
                modificar.pais = datosCliente.pais;
                modificar.idSocio = datosCliente.idSocio;
                setDatosCliente(modificar)
                break;

            case "email":
                modificar.email = e.target.value;
                modificar.id = datosCliente.id;
                modificar.codigo = datosCliente.codigo;
                modificar.nombre = datosCliente.nombre;
                modificar.direccion = datosCliente.direccion;
                modificar.poblacion = datosCliente.poblacion;
                modificar.provincia = datosCliente.provincia;
                modificar.cp = datosCliente.cp;
                modificar.telefono1 = datosCliente.telefono1;
                modificar.telefono2 = datosCliente.telefono2;
                modificar.telefono3 = datosCliente.telefono3;
                modificar.observacion = datosCliente.observacion;
                modificar.cif = datosCliente.cif;
                modificar.pais = datosCliente.pais;
                modificar.idSocio = datosCliente.idSocio;
                setDatosCliente(modificar)
                break;

            case "observacion":
                modificar.observacion = e.target.value;
                modificar.id = datosCliente.id;
                modificar.codigo = datosCliente.codigo;
                modificar.nombre = datosCliente.nombre;
                modificar.direccion = datosCliente.direccion;
                modificar.poblacion = datosCliente.poblacion;
                modificar.provincia = datosCliente.provincia;
                modificar.cp = datosCliente.cp;
                modificar.telefono1 = datosCliente.telefono1;
                modificar.telefono2 = datosCliente.telefono2;
                modificar.telefono3 = datosCliente.telefono3;
                modificar.email = datosCliente.email;
                modificar.cif = datosCliente.cif;
                modificar.pais = datosCliente.pais;
                modificar.idSocio = datosCliente.idSocio;
                setDatosCliente(modificar)
                break;
            case "cif":
                modificar.cif = e.target.value;
                modificar.id = datosCliente.id;
                modificar.nombre = datosCliente.nombre;
                modificar.codigo = datosCliente.codigo;
                modificar.direccion = datosCliente.direccion;
                modificar.poblacion = datosCliente.poblacion;
                modificar.provincia = datosCliente.provincia;
                modificar.cp = datosCliente.cp;
                modificar.telefono1 = datosCliente.telefono1;
                modificar.telefono2 = datosCliente.telefono2;
                modificar.telefono3 = datosCliente.telefono3;
                modificar.email = datosCliente.email;
                modificar.observacion = datosCliente.observacion;
                modificar.pais = datosCliente.pais;
                modificar.idSocio = datosCliente.idSocio;
                setDatosCliente(modificar)
                break;
            case "idSocio":
                modificar.idSocio = e.target.value;
                modificar.cif = datosCliente.cif;
                modificar.id = datosCliente.id;
                modificar.nombre = datosCliente.nombre;
                modificar.codigo = datosCliente.codigo;
                modificar.direccion = datosCliente.direccion;
                modificar.poblacion = datosCliente.poblacion;
                modificar.provincia = datosCliente.provincia;
                modificar.cp = datosCliente.cp;
                modificar.telefono1 = datosCliente.telefono1;
                modificar.telefono2 = datosCliente.telefono2;
                modificar.telefono3 = datosCliente.telefono3;
                modificar.email = datosCliente.email;
                modificar.observacion = datosCliente.observacion;
                modificar.pais = datosCliente.pais;
                setDatosCliente(modificar)
                break;

        }

        //let previa = {[e.target.name]: e.target.value 
    }

    const insertarCliente = () => {

        SetClientesERPSocioEnAPI(Object.keys(props.CLIENTE_SELECCIONADO).length > 0 ? 1 : 0, datosCliente).then((respuesta) => {
            if (respuesta.OK) {

                if (Object.keys(props.CLIENTE_SELECCIONADO).length === 0) {
                    MSGOK("Cliente añadido correctamente.")
                } else {
                    MSGOK("Cliente modificado correctamente.")
                }

                if (props.ACTUALIZAR_CLIENTES === null) {
                    props.ACTUALIZAR_SECUNDARIO()
                } else {
                    props.ACTUALIZAR_CLIENTES(0, 1, "A", props.ID_SOCIO)
                }

                props.CERRAR_FICHA(false)

            } else {
                props.CERRAR_FICHA(false)
            }
        })

    }

    return (
        <Drawer
            width={600}
            onClose={() => {
                props.CERRAR_FICHA(false)
                /*
                                store.dispatch({ type: "UPDATE_ID_CLIENTE_ID", id: "" });
                                store.dispatch({ type: "UPDATE_MODO_FICHA_CLIENTE_TALLER", esNuevoCliente: false })
                                */
            }}
            visible={props.ABRIR_FICHA}
            placement={"right"}
            bodyStyle={{ padding: '0px' }}
            style={{ zIndex: '9999999999', color: '#fff' }}>

            <div className='containerHeaderDrawer'>
                <div className='itemHeaderDrawer1'>
                    <CloseOutlined onClick={(e) => { props.CERRAR_FICHA(false) }}></CloseOutlined >
                    <div> {traducirPagina("titulo_ficha_cliente")}</div>
                </div>

                <div className='itemHeaderDrawer2'>

                </div>
            </div>






            <div className="p-2" style={{ height: (configApp.height - 70).toString() + "px", overflow: 'auto' }}>

                <div style={{ height: (configApp.height - 190).toString() + "px", }} className="ml-4 mr-4 mt-4" >
                    <Row gutter={[8, 8]} style={{ fontSize: '16px', fontWeight: '500', color: '#000' }}>
                        <Col md={24} >
                            <span>{`${traducirPagina("Codigo")}: `} </span>
                        </Col>

                        <Col md={10} >
                            <Input name="codigo" value={datosCliente.codigo} onChange={(e) => guardarDatosCliente(e)} />
                        </Col>
                        <Col md={24} >
                            <span>{"CIF: "}</span>
                        </Col>
                        <Col md={10} >
                            <Input name="cif" value={datosCliente.cif} onChange={(e) => guardarDatosCliente(e)} />
                        </Col>

                        <Col md={24}>
                            <span>{`${traducirPagina("Nombre")}: `} </span>
                        </Col>
                        <Col md={24} >
                            <Input name="nombre" value={datosCliente.nombre} onChange={(e) => guardarDatosCliente(e)} />
                        </Col>

                        <Col md={24} >
                            <span>{`${traducirPagina("Telefono")}: `} </span>
                        </Col>


                        <Col md={8} >
                            <Input name="telefono1" value={datosCliente.telefono1} onChange={(e) => guardarDatosCliente(e)} />
                        </Col>

                        <Col md={24}>
                            <span>{`${traducirPagina("Email")}: `} </span>
                        </Col>

                        <Col md={24}>
                            <Input name="email" value={datosCliente.email} onChange={(e) => guardarDatosCliente(e)} />
                        </Col>


                        <Col md={24}>
                            <span> {`${traducirPagina("Provincia")}: `} </span>
                        </Col>
                        <Col md={24} >
                            <Input name="provincia" value={datosCliente.provincia} onChange={(e) => guardarDatosCliente(e)} />
                        </Col>

                        <Col md={24}>
                            <span>{`${traducirPagina("Poblacion")}: `} </span>
                        </Col>

                        <Col md={24} >
                            <Input name="poblacion" value={datosCliente.poblacion} onChange={(e) => guardarDatosCliente(e)} />
                        </Col>

                        <Col md={20} >
                            <span>{`${traducirPagina("Direccion")}: `}  </span>
                        </Col>

                        <Col md={4}>
                            <span>{"CP"}</span>
                        </Col>

                        <Col md={20} >
                            <Input name="direccion" value={datosCliente.direccion} onChange={(e) => guardarDatosCliente(e)} />
                        </Col>

                        <Col md={4} >
                            <Input name="cp" value={datosCliente.cp} onChange={(e) => guardarDatosCliente(e)} />
                        </Col>

                    </Row>
                </div>

                <div style={{ flexGrow: '6', textAlign: 'right' }} className="ml-4 mr-4 mt-4" >
                    <button className="activebtnMenu2" onClick={() => { insertarCliente(); }} style={{ height: '40px', border: '0', borderRadius: '3px', fontSize: '13px', verticalAlign: 'bottom', color: '#000', cursor: 'pointer' }} ><SaveOutlined style={{ fontSize: '20px' }} /> <span style={{ verticalAlign: 'middle', fontSize: '16px' }}>{`${traducirPagina("Guardar_salir").toUpperCase()} `} </span>  </button>
                </div>

            </div>
        </Drawer>
    )
}


MantenimientoClienteTaller.propTypes = {
    ABRIR_FICHA: PropTypes.bool,
    CERRAR_FICHA: PropTypes.func,
    title: PropTypes.string,
    ES_NUEVO_CLIENTE: PropTypes.string,
    CLIENTE_SELECCIONADO: PropTypes.object,
    ACTUALIZAR_CLIENTES: PropTypes.func,
    ID_SOCIO: PropTypes.number,
    ACTUALIZAR_SECUNDARIO: PropTypes.func,

};

const mapStateToProps = (state, props) => {
    return {
        props: props,
        configApp: state.configApp
    };
}

export default connect(mapStateToProps)(MantenimientoClienteTaller);